"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Verified Caregiver & Nurses" | "Personalized Care Plans" | "Patient First Approach" | "Comfort & Dignity" */
    h30Text: ReactNode;
    /** Detected variants: "All staff are professionally trained, background-verified." | "Every care plan is tailored to medical conditions, recovery needs." | "We combine professional healthcare with emotional support, treating every patient." | "Our services focus on enabling patients to live comfortably at home." */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-6 d-flex" */
    className?: string;
    /** Detected variants: "about-item-nine flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "about-img" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/bg/about-img-one.png" */
    src?: string;
};
export type HomeNineAboutSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-4.png" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    sectionDiv0Div0Div0Div0Div0Link0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Play Video Play Video " */
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "2s" */
    sectionDiv0Div0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "ABOUT US" */
    sectionDiv0Div0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "We provide hospital grade care in the" */
    sectionDiv0Div0Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "comfort of your home" */
    sectionDiv0Div0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Our mission is to make healthcare more accessible by offering reliable medical support, post-operative recovery, chronic condition management, and daily assistance." */
    sectionDiv0Div0Div0Div1Div0Div0P0PText?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Div1ClassName?: string;
    /** Default: "element" */
    sectionDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/about-element-1.png" */
    sectionDiv0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-element-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    aboutSection6s: AboutSection6sItem[];
    aboutSection6sItemWrapper?: (item: AboutSection6sItem, content: ReactNode) => ReactNode;
    aboutSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageVisible?: boolean;
    aboutSection6sImageRenderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sH3Visible?: boolean;
    aboutSection6sH3Renderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
};

const HomeNineAboutSectionGenerated: FC<HomeNineAboutSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-img-4.png",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonDataText = "Play Video Play Video ",
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonProps,
    sectionDiv0Div0Div0Div0Div0Link0LinkDataFancybox = "",
    sectionDiv0Div0Div0Div0Div0Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div1Div0Div0Div0DivText = "ABOUT US",
    sectionDiv0Div0Div0Div1Div0Div0H20H2Text = "We provide hospital grade care in the",
    sectionDiv0Div0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div1Div0Div0H20Span0SpanText = "comfort of your home",
    sectionDiv0Div0Div0Div1Div0Div0P0PText = "Our mission is to make healthcare more accessible by offering reliable medical support, post-operative recovery, chronic condition management, and daily assistance.",
    sectionDiv0Div0Div0Div1Div0DivDataWowDuration = "2s",
    sectionDiv0ImageWithBasePath0ImageAlt = "element",
    sectionDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/about-element-1.png",
    sectionDiv0ImageWithBasePath0ImageVisible,
    sectionDiv0ImageWithBasePath0ImageRenderer,
    sectionDiv0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-element-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ClassName,
    sectionDiv0Div0Div0Div1Div0Div1ClassName,
    aboutSection6s,
    aboutSection6sItemWrapper,
    aboutSection6sRenderer,
    aboutSection6sImageVisible,
    aboutSection6sImageRenderer,
    aboutSection6sH3Visible,
    aboutSection6sH3Renderer,
    aboutSection6sImageProps,
    aboutSection6sH3Props,
}) => {
    return (
        <>
            <section className="about-section-nine section">
                <div className="about-nine">
                    <div className="container">
                        <div className={sectionDiv0Div0Div0ClassName ?? "row align-items-center"}>
                            <div className="col-xl-5 col-lg-6 wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                                <div className="about-img-nine d-none d-lg-block">
                                    {renderNode(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {renderNode(sectionDiv0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div0Div0Div0Div0Link0LinkHref} data-fancybox={sectionDiv0Div0Div0Div0Div0Link0LinkDataFancybox} {...(sectionDiv0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                            {renderNode(sectionDiv0Div0Div0Div0Div0Link0Button0ButtonVisible, sectionDiv0Div0Div0Div0Div0Link0Button0ButtonRenderer, (
                                                <button className="animate-button" data-text={sectionDiv0Div0Div0Div0Div0Link0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Div0Link0Button0ButtonProps ?? {})}>
                                                    <p className="button-text"></p>
                                                    <span className="button-circle">
                                                        <i className="isax isax-play"></i>
                                                    </span>
                                                </button>
                                            ))}
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6">
                                <div className="about-content-nine wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div1Div0DivDataWowDuration}>
                                    <div className="section-header section-header-nine">
                                        <div className="title">
                                            <span className="dot" />
                                            {sectionDiv0Div0Div0Div1Div0Div0Div0DivText}
                                        </div>
                                        {renderNode(sectionDiv0Div0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div0Div1Div0Div0H20H2Renderer, (
                                            <h2 className="section-title" {...(sectionDiv0Div0Div0Div1Div0Div0H20H2Props ?? {})}>
                                                {" "}
                                                {sectionDiv0Div0Div0Div1Div0Div0H20H2Text}
                                                {" "}
                                                <span className="text-primary text-decoration-underline">{sectionDiv0Div0Div0Div1Div0Div0H20Span0SpanText}</span>
                                                {" "}
                                            </h2>
                                        ))}
                                        <p className="paragraph">{sectionDiv0Div0Div0Div1Div0Div0P0PText}</p>
                                    </div>
                                    <div className={sectionDiv0Div0Div0Div1Div0Div1ClassName ?? "row g-4"}>
                                        {renderCollectionNode(
                                            aboutSection6s,
                                            (item: AboutSection6sItem) => (
                                                <div className={item.className ?? "col-lg-6 d-flex"} key={item.key}>
                                                    <div className={item.div0ClassName ?? "about-item-nine flex-fill"}>
                                                        {renderItemNode(aboutSection6sH3Visible, aboutSection6sH3Renderer, item, (
                                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection6sH3Props === "function" ? aboutSection6sH3Props(item) : (aboutSection6sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                        ))}
                                                        <p>{item.p0Text}</p>
                                                        {renderItemNode(aboutSection6sImageVisible, aboutSection6sImageRenderer, item, (
                                                            <SmartImage src={item.src ?? "/Templates/Doccure/img/bg/about-img-one.png"} alt={item.alt ?? "about-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof aboutSection6sImageProps === "function" ? aboutSection6sImageProps(item) : (aboutSection6sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                </div>
                                            ),
                                            aboutSection6sItemWrapper,
                                            aboutSection6sRenderer
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {renderNode(sectionDiv0ImageWithBasePath0ImageVisible, sectionDiv0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0ImageWithBasePath0ImageSrc} alt={sectionDiv0ImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionDiv0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                </div>
                <div data-template-tag="CompanySliderNine" />
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-two" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeNineAboutSectionGenerated;
